import { GetMeasuresFn, Measures } from "../../../../../rest/Misc";
import { EditSensorStoreState, EditSensorActions } from "../flux";
import { FlagActions } from "../../../../flux/Flag";
import { assertTrue } from "../../../../utils/assert";
import { ErrorActions } from "../../../../flux/Error";
import { Command } from "../../../../../Command";

export class LoadMeasuresCommand implements Command
{
    private readonly flagActions = new FlagActions();
    private readonly errorActions = new ErrorActions();
    private readonly editActions = new EditSensorActions();
    
    constructor(private getMeasures: GetMeasuresFn, private getState: () => EditSensorStoreState, private getCurrentDivisionId: () => number, private loadMeasuresInProgress: string, private loadMeasuresError: string)
    {        
    }
    
    execute = (): void => {
        const { editSession, draft }  = this.getState();
        const sameSession = () => editSession === this.getState().editSession;

        this.flagActions.set(this.loadMeasuresInProgress);
        (draft.id
            ? this.getMeasures({ SensorId: draft.id })
            : this.getMeasures({ DivisionId: this.getCurrentDivisionId() })
        )
        .then((resp: Measures) => {
            if(sameSession()) {
                const { Quantities } = resp;
                assertTrue(Quantities.length > 0, 'Quantities could not be empty');
                this.editActions.setMeasures(resp);
                
                const state = this.getState();
                const { QuantityId, UnitId } = state.draft;
                if(QuantityId && !UnitId) { // edit existed sensor
                    const quantity = Quantities.find(item => item.Id === QuantityId);
                    this.editActions.setQuantity(QuantityId, quantity.Units[0]);
                }
            }
        })
        .catch(err => sameSession() && this.errorActions.setError(err, this.loadMeasuresError))
        .then(() => sameSession() && this.flagActions.reset(this.loadMeasuresInProgress)); // finally
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Sensor/commands/LoadMeasuresCommand.ts